import { render, staticRenderFns } from "./ManagementCompany.vue?vue&type=template&id=6fba5274&scoped=true&"
import script from "./ManagementCompany.vue?vue&type=script&lang=js&"
export * from "./ManagementCompany.vue?vue&type=script&lang=js&"
import style0 from "./ManagementCompany.vue?vue&type=style&index=0&id=6fba5274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba5274",
  null
  
)

export default component.exports